import { View, type StyleProp, type ViewStyle } from "react-native";

import Text from "$src/core/components/atoms/Text/Text";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./AdTag.styles";

type Props = {
  accessibilityLabel?: string;
  style?: StyleProp<ViewStyle>;
};

const AdTag = ({ accessibilityLabel, style }: Props) => {
  const { t } = useTranslation();

  return (
    <View
      accessibilityRole="text"
      accessibilityLabel={accessibilityLabel ?? t("TV_REMOTE/AD")}
      style={[$.tag, style]}
    >
      <Text
        accessible={false}
        accessibilityRole="text"
        preset="tiny"
        style={$.tagText}
      >
        {t("TV_REMOTE/AD")}
      </Text>
    </View>
  );
};

export default AdTag;
